<template>
    <div class="row">
      <div :class="'col-xs-12'">
        <div class="row" v-if="camposFormulario.length">
          <span style="display:block;font-size: 25px;padding-bottom: 20px;">
              {{ this.formularioSelecionado.titulo }}
          </span>
          <template v-for="(listaDeCampos) in camposFormulario">            
            <TexInputComponent
              v-if="
                (listaDeCampos.type == 'text' ||
                listaDeCampos.type == 'text-mask' ||
                listaDeCampos.type == 'textarea' ||
                listaDeCampos.type == 'radio') &&
                verificadorCondicional(listaDeCampos.show)
              "
              :name="listaDeCampos.name"
              :type="verificarTipo(listaDeCampos.type)"
              :label="listaDeCampos.label"
              :placeholder="listaDeCampos.placeholder"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              v-model="values[listaDeCampos.name]"
              :key="values[listaDeCampos.name]"
              readonly
            />
  
            <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select' &&
                verificadorCondicional(listaDeCampos.show)
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="values[listaDeCampos.name] ? { [values[listaDeCampos.name]]: recuperarLabel(values[listaDeCampos.name], listaDeCampos.options) } : listaDeCampos.options "
              :class="[listaDeCampos.col, 'select-readonly', campoObrigatorio(listaDeCampos.validation)]"
              v-model="values[listaDeCampos.name]"
              :key="values[listaDeCampos.name]"
              readonly
            ></ComboboxInputComponent>

            <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select-avancado' &&
                verificadorCondicional(listaDeCampos.show)
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options[retornaValorEnderecamento(listaDeCampos.nome_enderecamento)]"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
              readonly
            ></ComboboxInputComponent>
  
            <DateInputComponent
                v-else-if="
                  listaDeCampos.type == 'date' ||
                  listaDeCampos.type == 'time' ||
                  listaDeCampos.type == 'datetime-local' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="listaDeCampos.label"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
                :key="listaDeCampos.id"
                v-model="values[listaDeCampos.name]"
                readonly
              />
  
          </template>
  
        </div>
  
      </div>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue';
  import '@/assets/css/formulate.css';
  import VueFormulate from '@braid/vue-formulate';
  import { pt } from '@braid/vue-formulate-i18n';
  import TexInputComponent from './TexInputComponent.vue';
  import ComboboxInputComponent from './ComboboxInputComponent.vue';
  import DateInputComponent from './DateInputComponent.vue';
  
  
  Vue.use(VueFormulate, {
    classes: {
      inputHasErrors: 'is-invalid',
      errors: 'list-unstyled text-danger',
    },
    locale: 'pt',
    plugins: [pt],
  });
  
  export default {
    name: 'ReadonlyFormComponent',
  
    components: {
      TexInputComponent,
      ComboboxInputComponent,
      DateInputComponent
    },
  
    props: {
      formularioSelecionado: {
        type: Object,
        required: true,
      },
      formValues: {
        type: Object,
        required: true,
      },    
      acaoFormulario: {
        type: String,
        required: false,
        default: 'cadastrar'
      },
      endpoint: {
        type: String,
        required: false,
        default: () => ''
      },
      exportarDados: {
        type: Boolean,
        required: false,
        default: false
      }
    },
  
    data () {
      return {
        values: { ...this.formValues },
        gatilhos: []
      }
    },
  
    computed: {
      camposFormulario () {        
        return this.formularioSelecionado.corpo.filter(campo => campo.name in this.formValues)
      }
    },
  
    methods: {
      verificadorCondicional (val) {
        return eval(val)
      },

      verificarTipo (type) {
        if (type == 'radio' || type == 'text-mask') return 'text';
        return type;
      },
  
      recuperarLabel (val, options) {
        for(const option in options) {
          if (val === option) {
            return options[option]
          }
        }
      },

      isFieldRequired(val) {
        if (typeof val === 'undefined') return false      
        return val.includes('required')
      },

      campoObrigatorio(val) {
        if(this.isFieldRequired(val)) {
          return 'input_obrigatorio'
        }
        return 
      },

      retornaValorEnderecamento (enderecamento) {
        /* O endereçamento representa e o vinculo com os campos que possibilita a captura do valor deles */
        if(Array.isArray(enderecamento)) {
          const valorEnderecamentos = enderecamento.map(nome => this.values[nome]).join('__');        
          return valorEnderecamentos
        }      
        if (enderecamento) {
          return this.values[enderecamento]
        } else {
          return ["Não existe valor disponível"]
        }
      },
    }
  };
  </script>
